import logo from './logo.svg';
import './App.css';
//import { useEffect } from 'react';
import React, {useState, useEffect} from "react";
import ReactDOM from "react-dom";
import Vibrant from "node-vibrant";
import Gradient from "javascript-color-gradient";

function App() {
    const [imgUrl, setImgUrl] = useState("/image20.png");
    const [palette, setPalette] = useState({});
    const [selectedFile, setSelectedFile] = useState(null); // File input state
    const [colorlightVibrant, setColor1] = useState(""); // String for LightVibrant color
    const [colordarkVibrant, setColor2] = useState(""); // String for DarkVibrant color
    const [colorlightMuted, setColor3] = useState(""); // String for LightMuted color
    const [colordarkMuted, setColor4] = useState(""); // String for DarkMuted color
    const [colorVibrant, setColor5] = useState(""); // String for LightMuted color
    const [colordMuted, setColor6] = useState(""); // String for DarkMuted color


    async function fetchPalette() {
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.src = imgUrl;
        const paletteData = await Vibrant.from(image).getPalette();
        setPalette(paletteData);

        if (paletteData.LightVibrant) {
            setColor1(paletteData.LightVibrant.getHex());
        }
        if (paletteData.DarkVibrant) {
            setColor2(paletteData.DarkVibrant.getHex());
        }
        if (paletteData.LightVibrant) {
            setColor3(paletteData.LightMuted.getHex());
        }
        if (paletteData.DarkVibrant) {
            setColor4(paletteData.DarkMuted.getHex());
        }
        if (paletteData.LightVibrant) {
            setColor5(paletteData.Muted.getHex());
        }
        if (paletteData.DarkVibrant) {
            setColor6(paletteData.Vibrant.getHex());
        }
    }

    useEffect(() => {
        fetchPalette();
    }, [imgUrl]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const fileReader = new FileReader();
            fileReader.onload = (e) => {
                setImgUrl(e.target.result); // Set the uploaded file's URL
            };
            fileReader.readAsDataURL(file);
            setSelectedFile(file);

        }
    };

    // const handleSubmit = () => {
    //   if (selectedFile) {
    //     fetchPalette(imgUrl); // Use the uploaded image URL for palette extraction
    //   } else {
    //     alert("Please select an image first.");
    //   }
    // };

    //  const gradientArray = new Gradient()


    return (
        <div className="App">
            <h1>Node-Vibrant test</h1>
            <div>
                <input
                    type="text"
                    value={imgUrl}
                    onChange={(e) => setImgUrl(e.target.value)}
                />
            </div>
            <p>Current image url:</p>
            <p>{imgUrl}</p>
            <img
                style={{
                    height: "200px",
                }}
                src={imgUrl}
            />
            {/* <div>
        <button onClick={(e) => handleSubmit()}>Submit</button>
      </div> */}
            <p>{JSON.stringify(palette)}</p>
            <div>Colors:</div>

            {palette !== undefined && palette.Vibrant !== undefined && (
                <div
                    style={{
                        backgroundColor: `${palette.Vibrant.getHex()}`,
                    }}
                >
                    {palette.Vibrant.getHex()}
                </div>
            )}

            {palette !== undefined && palette.LightVibrant !== undefined && (
                <div
                    style={{
                        backgroundColor: `${palette.LightVibrant.getHex()}`,
                    }}
                >
                    {palette.LightVibrant.getHex()}
                </div>
            )}

            {palette !== undefined && palette.DarkVibrant !== undefined && (
                <div
                    style={{
                        backgroundColor: `${palette.DarkVibrant.getHex()}`,
                    }}
                >
                    {palette.DarkVibrant.getHex()}
                </div>
            )}

            {palette !== undefined && palette.Muted !== undefined && (
                <div
                    style={{
                        backgroundColor: `${palette.Muted.getHex()}`,
                    }}
                >
                    {palette.Muted.getHex()}
                </div>
            )}

            {palette !== undefined && palette.LightMuted !== undefined && (
                <div
                    style={{
                        backgroundColor: `${palette.LightMuted.getHex()}`,
                    }}
                >
                    {palette.LightMuted.getHex()}
                </div>
            )}

            {palette !== undefined && palette.DarkMuted !== undefined && (
                <div
                    style={{
                        backgroundColor: `${palette.DarkMuted.getHex()}`,
                    }}
                >
                    {palette.DarkMuted.getHex()}
                </div>
            )}

            <div
                style={{
                    marginTop: "20px",
                    height: "100px",
                    width: "100%",
                    background: `linear-gradient(to right, ${colorlightVibrant}, ${colordarkVibrant})`,
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {colorlightVibrant && colordarkVibrant
                    ? `Gradient: ${colorlightVibrant} → ${colordarkVibrant} light colours`
                    : "Upload an image to generate gradient"}
            </div>

            <div
                style={{
                    marginTop: "20px",
                    height: "100px",
                    width: "100%",
                    background: `linear-gradient(to right, ${colorlightMuted}, ${colordarkMuted})`,
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {colorlightMuted && colordarkMuted
                    ? `Gradient: ${colorlightMuted} → ${colordarkMuted} dark colours`
                    : "Upload an image to generate gradient"}
            </div>

            <div
                style={{
                    marginTop: "20px",
                    height: "100px",
                    width: "100%",
                    background: `linear-gradient(to right, ${colordMuted}, ${colorVibrant})`,
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {colordMuted && colorVibrant
                    ? `Gradient: ${colordMuted} → ${colorVibrant} muted to vibrant`
                    : "Upload an image to generate gradient"}
            </div>
        </div>


    );
}

export default App;
